import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import React from "react";
import Welcome from "../components/Welcome";
import MainDashboardPage from "../containers/Dashboard";
import NewRoutePoint from "../containers/NewRoutePoint";
import { ROLE } from "../utils/helper";
import keycloakService from "../keycloakService";
import AddNewVehicle from "../containers/AddNewVehicle";
import ComingSoonPage from "../containers/ComingSoon";
import PrivilegeManagement from '../containers/PrivilegeManagement'

function RoutesIndex() {
  const handlePrivateRoute = (props) => {
    const isAuthenticated = keycloakService.isLoggedIn();
    const userHasRequiredRole = keycloakService.hasRole(props.requiredRoles);
    return isAuthenticated && userHasRequiredRole ? (
      <props.Component />
    ) : (
      <Welcome />
    );
  };
  return (
    <Router>
      <Routes>
        {/* <Route exact path="/" element={handleGuestRoute(Welcome)} /> */}
        <Route
          exact
          path="/"
          element={handlePrivateRoute({
            Component: MainDashboardPage,
            requiredRoles: [ROLE.User, ROLE.SuperAdmin],
          })}
        />
        <Route
          exact
          path="/:pageName"
          element={handlePrivateRoute({
            Component: NewRoutePoint,
            requiredRoles: [ROLE.User, ROLE.SuperAdmin],
          })}
        />
        <Route
          exact
          path="/add-vehicle/:pageName"
          element={handlePrivateRoute({
            Component: AddNewVehicle,
            requiredRoles: [ROLE.User, ROLE.SuperAdmin],
          })}
        />
        <Route
          exact
          path="/schedule-report/:pageName"
          element={handlePrivateRoute({
            Component: ComingSoonPage,
            requiredRoles: [ROLE.User, ROLE.SuperAdmin],
          })}
        />
        <Route
          exact
          path="/temp/:pageName"
          element={handlePrivateRoute({
            Component: AddNewVehicle,
            requiredRoles: [ROLE.User],
          })}
        />
        <Route
          exact
          path="/add-privilege/:pageName"
          element={handlePrivateRoute({
            Component: PrivilegeManagement,
            requiredRoles: [ROLE.SuperAdmin],
          })}
        />
      </Routes>
    </Router>
  );
}

export default RoutesIndex;
